import { useEffect } from 'react';

export function useDocumentTitle(title) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} | Alexandru Chiscari` : 'Alexandru Chiscari - DevOps & Design Portfolio';
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
}
